import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  CreateProjectMenuRequest,
  CreateProjectMenuResponse,
  GetProjectMenuRequest,
  GetProjectMenuResponse,
  UpdateProjectMenuItemRequest,
  UpdateProjectMenuItemResponse,
  UpdateMenuCustomFieldValueRequest,
  UpdateMenuCustomFieldValueResponse,
  ToggleProjectMenuItemsResponse,
  ToggleProjectMenuItemsRequest,
  GetProjectMenuByUniqueKeyResponse,
  GetProjectMenuByUniqueKeyRequest,
  UpdateMenuItemByUniqueKeyRequest,
  UpdateMenuItemByUniqueKeyResponse,
  UpdateMenuCustomFieldValueByUniqueKeyRequest,
  UpdateMenuCustomFieldValueByUniqueKeyResponse,
  UpdateMenuStatusByUniqueKeyRequest,
  UpdateMenuStatusByUniqueKeyResponse,
  GetMenuDocumentRequest,
} from "../../models/projectMenu.model";

const API_BASE_URL = environment.apiUrl;

export const CreateProjectMenu = createAsyncThunk<
  CreateProjectMenuResponse,
  CreateProjectMenuRequest,
  { rejectValue: string }
>("projectMenu/CreateProjectMenu", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}projectMenu/CreateProjectMenu`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }
    );

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: CreateProjectMenuResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch ");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// קבלת ערכים לטבלה ספציפית
export const GetProjectMenu = createAsyncThunk<
  GetProjectMenuResponse,
  GetProjectMenuRequest,
  { rejectValue: string }
>("projectMenu/GetProjectMenu", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}projectMenu/GetProjectMenu`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetProjectMenuResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch table values");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// עדכון פריט תפריט פרויקט
export const updateProjectMenuItem = createAsyncThunk<
  UpdateProjectMenuItemResponse,
  UpdateProjectMenuItemRequest,
  { rejectValue: string }
>(
  "projectMenu/updateProjectMenuItem",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/UpdateProjectMenuItem`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateProjectMenuItemResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update menu item");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

// עדכון ערך שדה מותאם אישית
export const updateMenuCustomFieldValue = createAsyncThunk<
  UpdateMenuCustomFieldValueResponse,
  UpdateMenuCustomFieldValueRequest,
  { rejectValue: string }
>(
  "projectMenu/updateMenuCustomFieldValue",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/UpdateMenuCustomFieldValue`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateMenuCustomFieldValueResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to update custom field value"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
export const ToggleProjectMenuItems = createAsyncThunk<
  ToggleProjectMenuItemsResponse,
  ToggleProjectMenuItemsRequest,
  { rejectValue: string }
>(
  "projectMenu/ToggleProjectMenuItems",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/ToggleProjectMenuItems`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: ToggleProjectMenuItemsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to update custom field value"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
export const GetProjectMenuByUniqueKey = createAsyncThunk<
  GetProjectMenuByUniqueKeyResponse,
  GetProjectMenuByUniqueKeyRequest,
  { rejectValue: string }
>(
  "projectMenu/GetProjectMenuByUniqueKey",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/GetProjectMenuByUniqueKey`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetProjectMenuByUniqueKeyResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to get project menu by unique key"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

// ✅ עדכון פריט תפריט לפי UniqueKey (ללא token)
export const updateMenuItemByUniqueKey = createAsyncThunk<
  UpdateMenuItemByUniqueKeyResponse,
  UpdateMenuItemByUniqueKeyRequest,
  { rejectValue: string }
>(
  "projectMenu/updateMenuItemByUniqueKey",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/UpdateMenuItemByUniqueKey`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateMenuItemByUniqueKeyResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update menu item");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

// ✅ עדכון שדה מותאם לפי UniqueKey (ללא token)
export const updateMenuCustomFieldValueByUniqueKey = createAsyncThunk<
  UpdateMenuCustomFieldValueByUniqueKeyResponse,
  UpdateMenuCustomFieldValueByUniqueKeyRequest,
  { rejectValue: string }
>(
  "projectMenu/updateMenuCustomFieldValueByUniqueKey",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/UpdateMenuCustomFieldValueByUniqueKey`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateMenuCustomFieldValueByUniqueKeyResponse =
        await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update custom field");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

// ✅ שליחת תפריט לאישור (עדכון סטטוס)
export const updateMenuStatusByUniqueKey = createAsyncThunk<
  UpdateMenuStatusByUniqueKeyResponse,
  UpdateMenuStatusByUniqueKeyRequest,
  { rejectValue: string }
>(
  "projectMenu/updateMenuStatusByUniqueKey",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/UpdateMenuStatusByUniqueKey`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateMenuStatusByUniqueKeyResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update status");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);

export const GetMenuDocument = createAsyncThunk<
  Blob,
  GetMenuDocumentRequest,
  { rejectValue: string }
>(
  "projectMenu/GetMenuDocument",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/GetMenuDocument`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const blob = await response.blob();
      return blob;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
